import { useState } from 'react';
import '../App.css';
import '../css/Nav design.css';
import { useNavigate } from 'react-router-dom';
import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import ApiResponse from '../model/response/ApiResponse';
import { ToastContainer, toast } from "react-toastify";
import { Oval } from "react-loader-spinner";
import logo from '../images/logo.jpeg';

function Searchpage(user_Id, OpponentId) {
const navigation = useNavigate();
    const rawVal = localStorage.getItem('loginVal');
    let loginVal = rawVal ? JSON.parse(rawVal) : null;
    const token = localStorage.getItem('token');




    const [isLoading, setIsLoading] = useState(false)
    const [opponentId, setOpponentId] = useState("");

   

    function showToast(message) {
        toast.success(message, {
            position: "top-right",
            autoClose: 2000
        });
    }
    function showToastFailed(message) {
        toast.error(message, {
            position: "top-right",
            autoClose: 2000
        });
    }

    function getSearchAPICall() {
        // setIsLoading(true);
        axios.get(
            ApiConfig.getUrl("User/user_search"),
            {
                params: {
                    User_Id: loginVal.user_Id, OpponentId: opponentId,userNum:loginVal.userNum
                },
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            }
        )

            .then(response => {
                const api = ApiResponse.fromJson(response.data);

                if (api.statusCode === 200) {
                    setIsLoading(false);
                    showToast(api.message);

                    const loggedUserId = loginVal.user_Id;

                    if (api?.status && api?.response?.userId) {

                        if (api.response.userId === loggedUserId) {
                            navigation("/Editprofile", {
                                state: { userId: api.response.userId }
                            });
                        } else {
                            navigation("/Customerdetails", {
                                state: { userId: api.response.userId }
                            });
                        }

                    } else {
                        showToastFailed(api.message);
                    }
                }
            })
           .catch (error => {
    setIsLoading(false);
    showToastFailed(error);
    return;
    // console.error("Error:", error);
});
    }

     function clicktoViewpage() {
        navigation('/Viewpage')
    }

    const disableRightClick = (e) => {
    e.preventDefault();
  };

return (
    <>

        <ToastContainer />
        <div className='fullview text-start' onContextMenu={disableRightClick}>

            {isLoading && (
                <div className="loader-overlay">
                    <Oval
                        height={60}
                        width={60}
                        color="#ffffff"
                        secondaryColor="#cccccc"
                        strokeWidth={4}
                        visible={true}
                    />
                </div>
            )}

            <div className="top-bar shadow-sm">
                            <div className='container'>
                                <ul className="d-flex align-items-center mb-0">
                                    <img src={logo} alt='logo' style={{ width: '70px', cursor: 'pointer' }} onClick={clicktoViewpage} />
                                    <li className='ms-auto' style={{listStyle:'none', cursor:'pointer'}} onClick={clicktoViewpage}>
                                       <i className="bi bi-house me-1"></i>Home
                                    </li>
                                </ul>
                            </div>
                        </div>
            <div className='container center mt-0'>
                <div>
                    <img className='logo_design mt-0 center' src={logo} alt='logo' />
                </div>
                <label className='h4 center'>Search your partner here</label>

                <div className="position-relative w-50  mt-3 ">
                    <input type="text" className=" form-control ps-2" placeholder="Eg: IMIT0001" value={opponentId}
                        onChange={(e) => setOpponentId(e.target.value)} />
                    <i className="bi bi-search position-absolute" onClick={() => getSearchAPICall()}
                        style={{ top: " 50%", right: " 10px", transform: " translateY(-50%)" }}></i>
                </div>
            </div>




        </div>
    </>
);
}

export default Searchpage;